import z from "zod";

export enum ZEntityErrorType {
  tech = "TECHNICAL_ERROR", // Такие ошибки не привязаны к какому-либо атрибуту
  attr = "ATTRIBUTE_VALIDATION", // эти ошибки обязательно привязаны к атрибуту
  rule = "BUSINESS_RULE", // здесь ошибки могут быть как привязаны к атрибуту, так и общего xарактера
}
export const zEntityErrorType = z.enum(ZEntityErrorType);

export const zEntityError = z.object({
  type: zEntityErrorType,
  message: z.string(),
  warning: z.boolean().nullish(),
  attributePath: z.string().nullish(),
});

export type ZEntityError = z.infer<typeof zEntityError>;
